"use client";

import Image from "next/image";
import Link from "next/link";
import Polygan from "./shapes/polygan";
import Button from "./button";
import { servicesLinks, navLinks } from "@/lib/navLinks";
import { FaMedium } from "react-icons/fa6";

function Footer() {
  return (
    <footer className="relative text-palette-neutral-1 overflow-hidden bg-black w-full h-auto flex flex-col px-4 md:px-20 pt-16 md:pt-32 pb-10 z-0">
      <div
        className="absolute w-full h-full hidden md:block"
        style={{ left: "100%", top: "70%" }}
      >
        <Polygan
          className="rotate-12 stroke-palette-secondary-2 opacity-20 w-[800px] h-[800px]"
          strokeWidth={0.02}
        />
      </div>
      <div className="z-10 w-full">
        <div className=" flex flex-col md:flex-row justify-between items-center pb-10 md:pb-20">
          <Image
            className="w-40 md:w-56"
            src="/assets/logo/asynq_logo_transparent.png"
            alt="Asynq Logo"
            width={500}
            height={500}
          />
          {/* <div className="flex items-center flex-wrap gap-4 mt-6 md:mt-0">
            <img
              className="w-20 md:w-20 h-auto max-h-20"
              src="/assets/images/AICPA SOC.svg"
              alt="AICPA"
            />
            <img
              className="w-20 md:w-20 h-auto max-h-20"
              src="/assets/images/GDPR Ready.png"
              alt="GDPR"
            />
            <img
              className="w-20 md:w-20 h-auto max-h-20"
              src="/assets/images/gpa.png"
              alt="GPA"
            />
            <img
              className="w-20 md:w-20 h-auto max-h-20"
              src="/assets/images/ISO 27001.svg"
              alt="ISO 27001"
            />
            <img
              className="w-20 md:w-20 h-auto max-h-20"
              src="/assets/images/Microsoft silver partner.png"
              alt="Microsoft Silver Partner"
            />
          </div> */}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-10 md:gap-y-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-10 md:gap-y-20">
            <div className="flex flex-col gap-3">
              <h2 className="text-xl font-bold mb-6">Join Asynq</h2>
              {servicesLinks.map((link) => (
                <Link key={link.text} className="loading-link" href={link.link}>
                  {link.text}
                </Link>
              ))}
            </div>
            <div className="flex flex-col gap-3">
              <h2 className="text-xl font-bold mb-6">Asynq</h2>
              {navLinks.map((link) => (
                <Link key={link.text} className="loading-link" href={link.link}>
                  {link.text}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <div className="flex flex-wrap items-center gap-4 justify-center sm:justify-start">
              <Link
                className="animated-btn w-12 h-12 grid place-content-center border-2 rounded-full"
                href="https://www.linkedin.com/company/asynq/"
              >
                <Image
                  className="w-6"
                  src="/assets/icons/linkedin.svg"
                  alt="Linkedin"
                  width={24}
                  height={24}
                />
              </Link>
              <Link
                className="animated-btn w-12 h-12 grid place-content-center border-2 rounded-full"
                href="https://twitter.com/asynq27160"
              >
                <Image
                  className="w-6"
                  src="/assets/icons/twitter.svg"
                  alt="Twitter"
                  width={24}
                  height={24}
                />
              </Link>
              <Link
                className="animated-btn w-12 h-12 grid place-content-center border-2 rounded-full"
                href="https://medium.com/@services_80623"
              >
                <FaMedium className="w-6 h-6" />
              </Link>
            </div>
            <p className="text-palette-secondary-2 mb-8 mt-4  text-center md:text-left">
              2.10, 91 Springboard, Building Number 145, Sector 44, Gurugram,
              Haryana 122003
            </p>


{/*  */}
<div className="flex items-center flex-wrap gap-4 mt-6 md:mt-0">
            <img
              className="w-16 md:w-16 h-auto max-h-20"
              src="/assets/images/AICPA SOC.svg"
              alt="AICPA"
            />
            <img
              className="w-20 md:w-20 h-auto max-h-20"
              src="/assets/images/GDPR Ready.png"
              alt="GDPR"
            />
            <img
              className="w-20 md:w-20 h-auto max-h-20"
              src="/assets/images/gpa.png"
              alt="GPA"
            />
            <img
              className="w-16 md:w-16 h-auto max-h-20"
              src="/assets/images/ISO 27001.svg"
              alt="ISO 27001"
            />
            <img
              className="w-20 md:w-20 h-auto max-h-20"
              src="/assets/images/Microsoft silver partner.png"
              alt="Microsoft Silver Partner"
            />
          </div>
{/*  */}


          </div>
        </div>
        <div className="text-center mt-6 md:mt-20">
          <Link href="/contact">
            <Button
              className="text-palette-neutral-4 font-semibold px-4 md:px-8 py-2 text-sm md:text-xl"
              className2="bg-palette-neutral-1"
              className3="bg-palette-neutral-4"
              text="Contact us"
            />
          </Link>
        </div>
        <div className="w-full flex flex-col md:flex-row items-center justify-between mt-10">
          <span className="text-palette-neutral-3">
            Asynq 2023. All rights reserved.
          </span>

          <Button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="border border-palette-neutral-1 px-3 md:px-4 py-1 text-xs md:text-sm mt-4 md:mt-0"
            text="Back To Top"
          />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
